import { sizeClasses } from "../../constants";
import { IconProps } from "../../types";
const SvgChevronUp = ({
  size = "regular",
  className = "",
  ...props
}: IconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
      viewBox="0 0 24 24"
      className={`${sizeClasses[size]} ${className}`}
      {...props}
    >
      <path
        fill="currentColor"
        fillRule="evenodd"
        d="m12 7.786-8.47 8.47a.75.75 0 1 1-1.06-1.061l8.508-8.509a1.415 1.415 0 0 1 2.044 0l8.508 8.509a.75.75 0 0 1-1.06 1.06z"
        clipRule="evenodd"
      />
    </svg>
  );
};
export default SvgChevronUp;
